import { renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "select-header-select sticky" }
const _hoisted_2 = { class: "placeholder" }
const _hoisted_3 = { class: "select-header__actions" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "select-header-select__item--actions" }
const _hoisted_6 = { class: "select-header-select__item--content" }
const _hoisted_7 = { class: "select-header-select__item--actions" }
const _hoisted_8 = {
  class: "select-header-select__create-container",
  "data-cy": "select-header-create-container"
}
const _hoisted_9 = {
  key: 0,
  class: "select-header-select__create-input-wrapper"
}
const _hoisted_10 = { class: "select-header-select__create-input-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_list_header = _resolveComponent("list-header")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_form_input = _resolveComponent("form-input")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["select-header-select__selection", {open: _ctx.showSelect}]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSelect = !_ctx.showSelect)),
      "data-cy": "select-header-clickable"
    }, [
      _renderSlot(_ctx.$slots, "header", {
        loading: _ctx.loading,
        prepend: _ctx.prepend,
        active: _ctx.activeOption,
        subtitle: _ctx.subtitle
      }, () => [
        _withDirectives(_createElementVNode("span", _hoisted_2, "...", 512), [
          [_vShow, _ctx.loading]
        ]),
        _withDirectives(_createVNode(_component_list_header, {
          title: `${_ctx.prepend || ''}${_ctx.prepend ? ' ' : ''}${_ctx.activeOption?.label || _ctx.placeholder}`,
          subtitle: _ctx.subtitle,
          size: "small"
        }, null, 8, ["title", "subtitle"]), [
          [_vShow, !_ctx.loading]
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "select-header-select__arrow" }, [
          _createElementVNode("div", { class: "t-icon" }, "d")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
        ])
      ], true)
    ], 2),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: "select-header-select__options",
      style: _normalizeStyle({marginTop: !_ctx.subtitle ? '-20px' : '-2px'}),
      "data-cy": "select-header-options"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredOptions, (option, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "select-header-select__option",
          onClick: ($event: any) => (_ctx.setActive(option)),
          key: `select-header-option-${option.label}`,
          "data-cy": "select-option"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "item-prepend", {
              option: option,
              index: i
            }, undefined, true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "label",
              style: _normalizeStyle({fontWeight: 'bold', padding: !_ctx.subtitle ? '12px 0 0' : '5px 0 0'})
            }, _toDisplayString(option.label), 5),
            (_ctx.subtitles.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "subtitle",
                  style: _normalizeStyle({paddingBottom: _ctx.subtitles[i] ? '5px' : '0px'})
                }, _toDisplayString(_ctx.subtitles[i]), 5))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _renderSlot(_ctx.$slots, "item-append", {
              option: option,
              index: i
            }, undefined, true)
          ])
        ], 8, _hoisted_4))
      }), 128)),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_spinner, {
          scale: 0.3,
          visible: _ctx.loading,
          style: {"margin":"0 auto"}
        }, null, 8, ["visible"]),
        (!_ctx.loading && _ctx.onCreate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _withDirectives(_createVNode(_component_ozn_button, {
                class: "flat minimal select-header-select__create-button",
                onClick: _ctx.beforeCreate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.createLabel), 1)
                ]),
                _: 1
              }, 8, ["onClick"]), [
                [_vShow, !_ctx.showCreate]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_10, [
                _createVNode(_component_ozn_button, {
                  class: "select-header-select__create-cancel flat minimal",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreate = false))
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Cancel")
                  ])),
                  _: 1
                }),
                _createVNode(_component_form_input, {
                  class: "select-header-select__create-input",
                  ref: "createinput",
                  modelValue: _ctx.createName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createName) = $event)),
                  onKeydown: _withKeys(_ctx.create, ["enter"]),
                  placeholder: "Enter a name and press Enter",
                  "data-cy": "select-header-create-input"
                }, null, 8, ["modelValue", "onKeydown"])
              ], 512), [
                [_vShow, _ctx.showCreate]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 4)), [
      [_vShow, _ctx.showSelect],
      [_directive_click_away, () => _ctx.showSelect ? _ctx.showSelect = false : null]
    ])
  ]))
}